import { AxiosError } from 'axios';
import { toast } from 'App';

interface AuthErrorResponse {
  error?: string;
  message?: string;
  statusCode?: number;
}

// Flags to prevent multiple toasts
let passwordChangedToastShown = false;
let adminDeactivatedToastShown = false;

export const resetPasswordChangedToastFlag = () => {
  passwordChangedToastShown = false;
};

export const resetAdminDeactivatedToastFlag = () => {
  adminDeactivatedToastShown = false;
};

export const handleAuthError = (error: AxiosError) => {
  if (error.response?.status !== 401) {
    return false;
  }

  const errorCode = (error.response?.data as AuthErrorResponse)?.error;

  switch (errorCode) {
    case 'PASSWORD_CHANGED_TOKEN_INVALID':
      handlePasswordChangedError();
      return true;

    case 'ADMIN_DEACTIVATED':
      handleAdminDeactivatedError();
      return true;

    default:
      return false;
  }
};

const handlePasswordChangedError = () => {
  if (!passwordChangedToastShown) {
    passwordChangedToastShown = true;
    toast({
      title: 'Password Changed',
      description: 'Your password has been changed. Please log in again.',
      status: 'info',
      duration: 5000,
      isClosable: true,
      position: 'top-right',
    });
  }

  localStorage.removeItem('accessToken');
  window.location.href = '/#/auth/sign-in';
};

const handleAdminDeactivatedError = () => {
  if (!adminDeactivatedToastShown) {
    adminDeactivatedToastShown = true;
    toast({
      title: 'Account Deactivated',
      description: 'Your account has been deactivated. Please contact support.',
      status: 'error',
      duration: 8000,
      isClosable: true,
      position: 'top-right',
    });
  }

  localStorage.removeItem('accessToken');
  window.location.href = '/#/auth/sign-in';
};
